import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuthStore } from "../../state/authStore";

export function AdminPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  // Defense in depth — ProtectedRoute already gates this, but make a non-admin
  // landing here bounce out instead of seeing a fake skeleton.
  useEffect(() => {
    if (user && user.role !== "admin") navigate("/", { replace: true });
  }, [user, navigate]);

  return (
    <main className="min-h-full">
      <div className="mx-auto w-full max-w-3xl px-4 pt-6 pb-10 sm:px-6 sm:pt-10 safe-top space-y-5">
        <header className="flex items-center justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-fg">Admin</h1>
            <p className="text-sm text-fg-muted">
              Invites verwalten und User blocken / freigeben.
            </p>
          </div>
          <NavLink
            to="/"
            className="min-h-[44px] inline-flex items-center px-3 py-2 rounded-lg text-sm text-fg-muted hover:text-fg hover:bg-card focus:outline-none focus-visible:ring-2 focus-visible:ring-outline-strong"
          >
            ← Quiz
          </NavLink>
        </header>

        <nav
          aria-label="Admin-Bereiche"
          role="tablist"
          className="flex flex-wrap bg-bg/40 border border-outline-soft rounded-lg p-1 gap-1"
        >
          <TabLink to="/admin/invites" label="Invites" testid="tab-invites" />
          <TabLink to="/admin/users" label="Users" testid="tab-users" />
          <TabLink to="/admin/vocab" label="Vokabeln" testid="tab-vocab" />
          <TabLink to="/admin/stats" label="Stats" testid="tab-stats" />
          <TabLink to="/admin/usage" label="KI-Nutzung" testid="tab-usage" />
        </nav>

        <Outlet />
      </div>
    </main>
  );
}

function TabLink({ to, label, testid }: { to: string; label: string; testid: string }) {
  return (
    <NavLink
      to={to}
      role="tab"
      data-testid={testid}
      className={({ isActive }) =>
        [
          "min-h-[40px] px-4 rounded-md text-sm font-semibold inline-flex items-center transition-colors",
          isActive
            ? "bg-accent text-accent-on shadow-card"
            : "text-fg-soft hover:bg-card hover:text-fg",
        ].join(" ")
      }
    >
      {label}
    </NavLink>
  );
}
